import { LogIn } from 'lucide-react';
import { Link } from 'react-router';

import { Button } from '@/components/ui/button';

import {
  AuthTemplate,
  FooterLinks,
} from '@/pages/unauthenticated/auth/components';

export const ExpiredInviteToken = ({ heading }: { heading: string }) => {
  return (
    <AuthTemplate
      heading={heading}
      subheading={<ExpiredInviteSubheading />}
      footer={<FooterLinks />}
    >
      <Button asChild>
        <Link to="/">
          <LogIn className="w-4 h-4 mr-2" />
          Continue to FlagSync
        </Link>
      </Button>
    </AuthTemplate>
  );
};

export function ExpiredInviteSubheading() {
  return (
    <span>
      Uh oh, this link has <span className="font-semibold">expired</span>.
      Please contact your FlagSync administrator to request another invite.
    </span>
  );
}
